import { useState } from "react";
import { themeStyle } from "../../components/Components.js";
import Fade from "@mui/material/Fade";
import TextField from "@mui/material/TextField";
import axios from "axios";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import CircularProgress from "@mui/material/CircularProgress";
import Snackbar from "@mui/material/Snackbar";
import { useSelector, useDispatch } from "react-redux";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import {
  API_URL,
  MAIN_TITLE,
  alertMessage,
  DOMAIN_URL,
  SIDEBAR,
  ONLYLOGO,
  APPBAR,
} from "../../actions/auth.js";
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import Tooltip from "@mui/material/Tooltip";
import LiveHelpIcon from "@mui/icons-material/LiveHelp";
import { login } from "../../actions/auth.js";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckCircle from "@mui/icons-material/CheckCircle";
import { Link, useNavigate } from "react-router-dom";
import { add } from "date-fns";

function Initialize() {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showSnack, setShowSnack] = useState(false);
  const [snack, setSnack] = useState("");
  const [page, setPage] = useState("HELLO");
  const [institutionId, setInstitutionId] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");

  const [user_id, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [selectedState, setSelectedState] = useState("Maharashtra");
  const [selectedCity, setSelectedCity] = useState("Mumbai City");

  const [middlename, setMiddlename] = useState("");
  const [fullName, setFullName] = useState("");

  const [clearText, setClearText] = useState("");

  function createAlert(type, title, message) {
    dispatch(alertMessage(type, title, message));
  }

  if (state.auth.alert) {
    setSnack({
      title: state.auth.alert.title,
      message: state.auth.alert.message,
      type: state.auth.alert.type,
    });
    setShowSnack(true);
    dispatch({ type: "REMOVE_ALERT" });
  }

  const validateUserId = (user_id) => {
    return user_id.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-z\-0-9]+\.)+[a-z]{2,}))$/
    );
  };

  function registerUser() {
    if (institutionId.length == 0) {
      createAlert("ERROR", "Error", "Enter Institution ID to continue.");
    } else if (!validateUserId(user_id)) {
      createAlert("ERROR", "Error", "Enter valid UserId ID");
    } else {
      if (password.length > 7 && password == password2) {
        var body = {};
        const config = {
          headers: {
            Authorization: state.auth.token,

            "Content-Type": "application/json",
          },
        };
        body["password"] = password;
        body["user_id"] = user_id;
        body["institution_id"] = institutionId;
        body["type"] = "MANAGER";
        body = JSON.stringify(body);
        axios
          .post(API_URL + "/register_user", body, config)
          .then((res) => {
            setPage("DETAILS");
          })
          .catch((err) => {
            createAlert("ERROR", "Error", err.response.data);
          });
      } else {
        createAlert(
          "ERROR",
          "Password Error.",
          "Password Mismatch or less than 8 characters"
        );
      }
    }
  }

  function checkInstitution() {
    if (institutionId.length == 0) {
      createAlert("ERROR", "Error", "Enter a name for your institution.");
    } else {
      var body = {};
      const config = {
        headers: {
          Authorization: state.auth.token,

          "Content-Type": "application/json",
        },
      };
      body["institution_id"] = institutionId;
      body = JSON.stringify(body);
      axios
        .post(API_URL + "/check_institution", body, config)
        .then((res) => {
          if (res.data["initiated"]) {
            setPage("REGISTER");
          } else {
            createAlert(
              "ERROR",
              "Institution setup Incomplete",
              "This Institution's setup is not yet complete. Try again later."
            );
          }
        })
        .catch((err) => {
          createAlert("ERROR", "Error", err.response.data);
        });
    }
  }

  function submitDetails() {
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,

        "Content-Type": "application/json",
      },
    };

    if (fullName.length == 0) {
      createAlert("ERROR", "Error", "Please fill all the fields.");
    } else {
      body["user_id"] = user_id;
      body["full_name"] = fullName;
      body["middlename"] = middlename;

      axios
        .post(API_URL + "/initialize_manager_profile", body, config)
        .then((res) => {
          setPage("FINISHED");
        })
        .catch((err) => {
          createAlert("ERROR", "Error", err.response.data);
        });
    }
  }

  function getPage() {
    switch (page) {
      case "HELLO":
        return (
          <div style={{ width: "100%" }}>
            <h1 style={{ marginTop: "45px" }}>Welcome to {MAIN_TITLE}!</h1>
            <h3 style={{ marginTop: "-15px" }}>Let's get started.</h3>
            <br></br>
            <p>Enter Institution ID to continue.</p>
            <div style={{ width: "50%" }}>
              <TextField
                fullWidth
                style={{ marginTop: "2px" }}
                value={institutionId}
                size="small"
                onChange={(e) => setInstitutionId(e.target.value)}
                placeholder={"Institution ID"}
                variant="outlined"
              />
            </div>
            <br></br>
            <br></br>
            <Link
              style={{ textDecoration: "none", textAlign: "right" }}
              to="/login"
            >
              Already registered? Login here.
            </Link>
            <Button
              style={{
                width: "100px",
                backgroundColor: themeStyle.primaryColor,
                color: "white",

                height: "30px",
                position: "absolute",
                bottom: 30,
                right: 30,
              }}
              onClick={() => checkInstitution()}
            >
              Next
            </Button>
          </div>
        );

      case "REGISTER":
        return (
          <div style={{ width: "100%", animation: "fadeInAnimation ease 1s" }}>
            <h1 style={{ marginTop: "45px" }}>Registration</h1>
            <h3 style={{ marginTop: "-15px", marginBottom: "25px" }}>
              You are required to create an account to use our services.
            </h3>
            <div style={{ width: "50%" }}>
              <p>UserId</p>
              <TextField
                style={{ marginTop: "-10px" }}
                value={user_id}
                fullWidth
                size="small"
                onChange={(e) => setUserId(e.target.value)}
                placeholder={"E-mail"}
                variant="outlined"
              />
              <p>Password</p>
              <TextField
                style={{ marginTop: "-10px" }}
                value={password}
                fullWidth
                type={clearText ? "text" : "password"}
                size="small"
                onChange={(e) => setPassword(e.target.value)}
                placeholder={"Password"}
                variant="outlined"
                autoComplete="password"
                InputProps={{
                  endAdornment: (
                    <IconButton
                      size="small"
                      style={{ marginRight: "-8px", paddingLeft: "10px" }}
                      onClick={() => setClearText(!clearText)}
                    >
                      {clearText ? (
                        <VisibilityOffIcon
                          style={{ color: themeStyle.primaryColor }}
                        />
                      ) : (
                        <VisibilityIcon
                          style={{ color: themeStyle.primaryColor }}
                        />
                      )}
                    </IconButton>
                  ),
                }}
              />
              <p>Confirm Password</p>
              <TextField
                style={{ marginTop: "-10px" }}
                value={password2}
                fullWidth
                type={clearText ? "text" : "password"}
                size="small"
                onChange={(e) => setPassword2(e.target.value)}
                placeholder={"Confirm Password"}
                variant="outlined"
              />
            </div>

            <Button
              style={{
                width: "100px",
                backgroundColor: themeStyle.primaryColor,
                color: "white",

                height: "30px",
                position: "absolute",
                bottom: 30,
                right: 30,
              }}
              onClick={() => registerUser()}
            >
              Next
            </Button>
          </div>
        );
      case "DETAILS":
        return (
          <div style={{ width: "100%", animation: "fadeInAnimation ease 1s" }}>
            <h3 style={{ marginTop: "45px" }}>
              We would like to know some additional details for your profile
              page.
            </h3>
            <div style={{ display: "flex" }}>
              <div style={{ width: "33.33%", marginRight: "25px" }}>
                {" "}
                <p>Full Name</p>
                <TextField
                  style={{ marginTop: "-10px" }}
                  value={fullName}
                  fullWidth
                  size="small"
                  onChange={(e) => setFullName(e.target.value)}
                  placeholder={"Full Name"}
                  variant="outlined"
                  required
                />
              </div>
            </div>
            <Button
              style={{
                width: "100px",
                backgroundColor: themeStyle.primaryColor,
                height: "30px",
                position: "absolute",
                bottom: 30,
                right: 30,
              }}
              onClick={() => submitDetails()}
            >
              Next
            </Button>{" "}
          </div>
        );
      case "FINISHED":
        return (
          <div
            style={{
              width: "100%",
              animation: "fadeInAnimation ease 1s",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <h1 style={{ marginTop: "145px", textAlign: "center" }}>
              Finished!
            </h1>
            <CheckCircle
              style={{
                fontSize: "100px",
                color: "#5cb85c",
                textAlign: "center",
              }}
            />
            <br></br>
            Please wait for your account to be approved by
            <p
              style={{
                color: themeStyle.primaryColor,
                marginTop: "5px",
              }}
            >
              The Principal.
            </p>
          </div>
        );

      default:
        setPage("HELLO");
        return <h1>Shite</h1>;
    }
  }

  function Copyright() {
    return (
      <Typography variant="body2" color="black" align="center">
        {"Copyright © "}
        {MAIN_TITLE} {new Date().getFullYear()}
        {"."}
      </Typography>
    );
  }

  return (
    <div style={{ width: "100%" }}>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        autoHideDuration={6000}
        open={showSnack}
        onClose={() => setShowSnack(false)}
      >
        <Card style={{ minWidth: "350px", padding: "10px" }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ display: "flex" }}>
              {snack["type"] == "SUCCESS" ? (
                <CheckCircleIcon
                  style={{ color: "#2ca25f", fontSize: "44px" }}
                />
              ) : snack["type"] == "MESSAGE" ? (
                <ErrorIcon
                  style={{ color: themeStyle.primaryColor, fontSize: "44px" }}
                />
              ) : (
                <ErrorIcon style={{ color: "#ff3333", fontSize: "44px" }} />
              )}
              <div style={{ marginLeft: "10px" }}>
                <b style={{ fontSize: "15px" }}>{snack["title"]}</b>
                <br></br>
                <span>{snack["message"]}</span>
              </div>
            </div>
            <IconButton size="small">
              <CloseIcon
                onClick={() => setShowSnack(false)}
                style={{ color: themeStyle.primaryColor }}
              />
            </IconButton>
          </div>
        </Card>
      </Snackbar>
      <AppBar
        position="fixed"
        elevation={1}
        style={{
          backgroundColor: "white",
          height: "50px",
        }}
      >
        <Toolbar
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <a style={{ textDecoration: "none" }} href={DOMAIN_URL}>
            <img
              style={{ maxHeight: "40px", marginTop: "-15px" }}
              src={require("../../img/" + APPBAR)}
            />
          </a>
          <a style={{ textDecoration: "none" }} href={DOMAIN_URL}>
            <Button
              style={{
                backgroundColor: themeStyle.primaryColor,
                color: "white",
                fontSize: "16px",
                marginTop: "3px",
                height: "30px",
                marginTop: "-20px",
              }}
            >
              <ChevronLeftIcon style={{ fontSize: "35px" }} /> Back to Home
            </Button>
          </a>
        </Toolbar>
      </AppBar>
      <div style={{ padding: "50px" }}>{getPage()}</div>
    </div>
  );
}
export default Initialize;
